import { atom } from 'jotai';

export const isMobileFiltersPanelOpenAtom = atom(false);

type RightPanelHeader = { title?: string; onClose: () => void };
export const rightPanelHeaderAtom = atom<RightPanelHeader | null>(null);
